export default __webpack_public_path__ + "static/doosindoos-desktop-da48f8868a39378a75621c93c1605794.svg";